import {downloadTranslations as superDL, translate} from "../../services/i18n";

const basePath = '/xrm/media/filter/press/';
let baseURL;

export function downloadTranslations(host: string, language: string, country: string) {
    baseURL = new URL(basePath, host);
    return superDL(baseURL, language, country);
}

export function $t(key: string, ...params: string[]) {
    return translate.apply(undefined, [baseURL, key].concat(params));
}
